import React, { useEffect, useState } from "react";
import { getNoticeContent } from "@/firebase_group";
import { FirebaseGroupNewsClick } from "@/firebase/click/groupClick";

import styles from "./index.module.scss";
import { ReactComponent as IconClose } from "../home/icons/icon_close.svg";

interface noticeData {
  title: string;
  desc: string;
  img: string;
  url: string;
  firebaseParameter: string;
  isValid: boolean;
}

const Notice = () => {
  const [display, setDisplay] = useState(true);
  const [noticeData, setNoticeData] = useState<noticeData[]>([]);
  const NoticeDisplayed = localStorage.getItem("NoticeDisplayed");

  const handleNoticeClose = () => {
    setDisplay(false);
    localStorage.setItem("NoticeDisplayed", "true");
  };

  useEffect(() => {
    const getNoticeData = async () => {
      try {
        const data = await getNoticeContent();
        const validNotice = data?.filter((v: noticeData) => v.isValid);
        if (validNotice.length > 0) setNoticeData(data);
      } catch (error) {
        console.log("Error fetching notice data:", error);
        return null;
      }
    };
    getNoticeData();
  }, []);

  return (
    <>
      {display && !NoticeDisplayed && noticeData?.length > 0 && (
        <div className={styles.container}>
          <div className={styles.noticeWrapper}>
            <IconClose
              className={styles.iconClose}
              onClick={() => {
                handleNoticeClose();
                FirebaseGroupNewsClick("cancel");
              }}
            />
            <div className={styles.noticeTitle}>最新消息</div>

            <div className={styles.noticeBody}>
              {noticeData.map((v, i) => {
                return v.url ? (
                  <a
                    key={i}
                    href={v.url || "https://www.ohyagroup.com/"}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => FirebaseGroupNewsClick(v.firebaseParameter)}
                  >
                    <div className={styles.noticeItem}>
                      <img
                        src={v.img || "/assets/images/website_news_1.jpg"}
                        alt=""
                      />
                      <div className={styles.content}>
                        <div className={styles.title}>{v.title}</div>
                        <div className={styles.desc}>{v.desc}</div>
                        <button>查看更多</button>
                      </div>
                    </div>
                  </a>
                ) : (
                  <div className={styles.noticeItem} key={i}>
                    <img
                      src={v.img || "/assets/images/website_news_1.jpg"}
                      alt=""
                    />
                    <div className={styles.contentScroll}>
                      <div className={styles.title}>{v.title}</div>
                      <div className={styles.desc}>{v.desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Notice;
